<template>
  <header>
    <nav
      class="
        navbar navbar-light navbar-expand
        bg-primary
        shadow
        topbar
        static-top
        d-flex
        justify-content-between
      "
      style="z-index: 999 !important"
    >
      <div class="container-fluid p-0 m-0">
        <router-link :to="{ name: nameRoutes.RICHIESTE }">
          <div class="d-flex align-items-center">
            <LogoAzienda class="img-fluid float-left NavbarAssociationLogo" />
            <span id="LogoTitolo" class="Bolder ml-2"
              >Servizio<br />
              di ristorazione</span
            >
          </div>
        </router-link>
        <ul class="nav navbar-nav flex-nowrap ml-auto p-0">
          <li class="nav-item dropdown no-arrow">
            <a
              class="dropdown-toggle nav-link p-0 w-100 border-width-0"
              data-toggle="dropdown"
              aria-expanded="false"
              href="#"
            >
              <div class="SisrUser d-flex align-items-center text-gray-800">
                <div class="d-flex flex-column mr-2">
                  <p class="m-0 d-lg-inline small text-left font-weight-bold">
                    {{ utente ? N4M.CAPITALIZESTRING(utente.nome) : ""
                    }}<br />{{
                      utente ? N4M.CAPITALIZESTRING(utente.cognome) : ""
                    }}
                  </p>
                </div>
                <font-awesome-icon icon="user" class="HeaderUserIcon" />
              </div>
            </a>
            <div
              class="
                dropdown-menu
                shadow
                dropdown-menu-right
                animated--grow-in
                NavbarDropdownMenu
              "
              role="menu"
            >
              <button
                class="dropdown-item text-dark TextLink"
                role="presentation"
                @click="switchDarkMode"
              >
                <font-awesome-icon icon="sun" class="mr-1" />&nbsp;
                {{ LABEL.LAYOUT.DARK_MODE(darkMode) }}
              </button>
              <button
                class="dropdown-item text-dark TextLink"
                role="presentation"
                @click="$emit('logouted')"
              >
                <font-awesome-icon icon="sign-out-alt" class="mr-1" />&nbsp;{{
                  LABEL.LAYOUT.LOGOUT
                }}
              </button>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { darkModeMixin } from "../../libs/mixins/application";
import { nameRoutes } from "../../libs/router/nameRoutes";
import N4M from "../../libs/utils/commons";
import LABEL from "../../libs/utils/label";
export default {
  mixins: [darkModeMixin],
  data() {
    return { N4M, nameRoutes, LABEL };
  },
  computed: {
    utente: function () {
      return this.$store.getters["UserDetails/getUserDetails"];
    },
  },
};
</script>
